import { forwardRef } from 'react';

import { SvgStyled } from '@sternum/web/icons/icons.styles';
import { IconProps } from '@sternum/web/icons/icons.types';

export const DocumentTextIcon = forwardRef<SVGSVGElement, IconProps>(function DocumentTextIcon(
  { color = '', height = 12, width = 12, hasCursorPointer = false, ...props },
  ref,
) {
  return (
    <SvgStyled
      ref={ref}
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-has-cursor-pointer={hasCursorPointer}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.25053 3.25053C2.59163 3.90942 2.23077 4.99916 2.23077 6.78462V11.2154C2.23077 13.0008 2.59163 14.0906 3.25053 14.7495C3.90942 15.4084 4.99916 15.7692 6.78462 15.7692H11.2154C13.0008 15.7692 14.0906 15.4084 14.7495 14.7495C15.4084 14.0906 15.7692 13.0008 15.7692 11.2154V8.13846H13.4308C12.289 8.13846 11.332 7.9561 10.6879 7.31207C10.0439 6.66803 9.86154 5.71101 9.86154 4.56923V2.23077H6.78462C4.99916 2.23077 3.90942 2.59163 3.25053 3.25053ZM11.0923 3.10105L14.8989 6.90769H13.4308C12.3572 6.90769 11.8373 6.72082 11.5582 6.44178C11.2792 6.16274 11.0923 5.64283 11.0923 4.56923V3.10105ZM2.38024 2.38024C3.38288 1.3776 4.87777 1 6.78462 1H10.4769C10.6401 1 10.7967 1.06483 10.9121 1.18024L16.8198 7.08793C16.9352 7.20334 17 7.35987 17 7.52308V11.2154C17 13.1222 16.6224 14.6171 15.6198 15.6198C14.6171 16.6224 13.1222 17 11.2154 17H6.78462C4.87777 17 3.38288 16.6224 2.38024 15.6198C1.3776 14.6171 1 13.1222 1 11.2154V6.78462C1 4.87777 1.3776 3.38288 2.38024 2.38024ZM4.69231 9.73846C4.69231 9.39859 4.96782 9.12308 5.30769 9.12308H9.73846C10.0783 9.12308 10.3538 9.39859 10.3538 9.73846C10.3538 10.0783 10.0783 10.3538 9.73846 10.3538H5.30769C4.96782 10.3538 4.69231 10.0783 4.69231 9.73846ZM4.69231 12.6923C4.69231 12.3524 4.96782 12.0769 5.30769 12.0769H8.26154C8.60141 12.0769 8.87692 12.3524 8.87692 12.6923C8.87692 13.0322 8.60141 13.3077 8.26154 13.3077H5.30769C4.96782 13.3077 4.69231 13.0322 4.69231 12.6923Z"
        fill={color || 'currentColor'}
      />
    </SvgStyled>
  );
});
